export default __webpack_public_path__ + "static/media/product-3.3116f55a.jpg";